(function (window, $) {
  /**
   * This class sets up the progress goal modal
   * @returns {void}
   */
  var ProgressGoalDialog = function () {
    this.goal = null;
    this.classesTaken = $progressTimeLineContainer.data('classes-taken');
    this.campaignId = $progressTimeLineContainer.data('campaign-id');
    this.state = null;
    this.clickedElement = null;

    this.updateModalDetails = function () {
      $changeGoalDialogContainer.find('.change-goal-dialog-text-main .description').empty();

      var goalRides = this.goal + ' rides';
      $changeGoalDialogContainer.find('.change-goal-dialog-header h1').text(goalRides);

      var dialogHeaderH2 = $changeGoalDialogContainer.find('.change-goal-dialog-header h2');
      var dialogContainerDescription = $changeGoalDialogContainer.find('.change-goal-dialog-text-main .description');

      if (this.state === 'your') {
        dialogHeaderH2.text('Your Goal');
        $changeGoalDialogContainer.find('.change-goal-dialog-button.button-done').show();
      } else {
        dialogHeaderH2.text(this.state === 'next' ? 'Next Goal' : 'New Goal');
        $changeGoalDialogContainer.find('.change-goal-dialog-button.button-change').show();
      }

      if (this.classesTaken >= this.goal) {
        dialogContainerDescription.html('Congrats, you scored!');
      } else {
        dialogContainerDescription.html("At <span class='number-of-rides'>" + goalRides + '</span> you get');
      }
    };

    this.updateRidersGoal = function () {
      $.ajax({
        context: this,
        url: '/turn-it-up/me/updategoal/',
        data: {
          'goal': this.goal,
          'campaignId': this.campaignId
        },
        type: 'put',
        dataType: 'json',
        success: function () {
          $('.campaign-progress-ride-goal').removeClass('your-goal next-goal');

          var $newGoal = $(this.clickedElement);
          $newGoal.addClass('your-goal');
          $newGoal.nextAll('.campaign-progress-ride-goal').first().addClass('next-goal');

          updateDashboardUI(this.goal);

          // Send mparticle event for goal change
          var eventData = {'Old Goal': this.currentGoalRideNumber, 'New Goal': this.goal};
          SC.analytics.mp.logEvent('Challenge_Spring19 - Change Goal', 'navigation', eventData);

          confirmation(null, ('Your goal has been updated.'));
        },
        error: function () {
          confirmation(null, ('Could not fulfill this request.'));
        },
        complete: function () {
          this.close();
        }
      });
    };

    this.open = function (clickedElement) {
      this.clickedElement = clickedElement;
      this.goal = this.clickedElement.find('.ride-number').text();

      var $dashboard = $('.campaign-dashboard');
      if ($dashboard.length) {
        this.currentGoalRideNumber = $dashboard.find('input[name=current_goal]').val();
      } else {
        var currentGoal = $progressTimeLineContainer.find('.your-goal .ride-number');
        this.currentGoalRideNumber = currentGoal.text();
      }

      // Figure out the state (ie. What goal we're clicking on)
      if (this.clickedElement.hasClass('your-goal')) {
        this.state = 'your';
      } else if (this.clickedElement.hasClass('next-goal')) {
        this.state = 'next';
      } else if (Number(this.goal) > Number(this.currentGoalRideNumber)) {
        this.state = 'new';
      } else {
        this.state = 'prev';
      }

      // Show the correct prizes
      $changeGoalDialogContainer.find('.prize-container > div').hide();
      $changeGoalDialogContainer.find('.change-goal-dialog-button').hide();
      $changeGoalDialogContainer.find('.prize-container .' + this.goal + '-rides-goal').show();

      // Update the texts
      this.updateModalDetails();
      SC.analytics.mp.logEvent('Challenge_Spring19 - View Goal', 'navigation', {'Goal Viewed': this.goal});
      $changeGoalDialogContainer.show();
    };

    this.close = function () {
      this.goal = null;
      $changeGoalDialogContainer.hide();
    };

    this.confirm = function () {
      this.updateRidersGoal();
    };
  };

  function updateDashboardUI(newGoal) {
    var $dashboard = $('.campaign-dashboard.started:not(".campaign-share")');
    var hasEnded = $dashboard.hasClass('ended');

    if ($dashboard.length) {
      var $currentGoalInput   = $dashboard.find('input[name=current_goal]');
      var $classesTakenInput  = $dashboard.find('input[name=classes_taken]');

      var goal = newGoal || $currentGoalInput.val();
      var classesTaken = $classesTakenInput.val();

      var $progressMessage = $('.campaign-dashboard-progress-message');

      // Set the progress message
      var message = '';
      var classesTakenMessage = 'You\'ve taken ' + classesTaken + ' out of ' + goal + ' rides.';

      if (Number(classesTaken) === 0) {
        message = classesTakenMessage + ' Claim your Warrior status.';
      } else {
        var percentComplete = (classesTaken / goal) * 100;

        if (percentComplete < 50) {
          message = 'Nice! ' + classesTakenMessage;
        } else if (percentComplete < 100) {
          message = classesTakenMessage + ' You’re so close!';
        } else {
          message = classesTakenMessage + ' You’re amazing!';
        }

        // Update Progress Bar
        $('.campaign-dashboard-progress-bar-fill').css('width', percentComplete + '%');
      }

      // Do not update message if the campaign has ended
      if (!hasEnded) {
        $progressMessage.html(message);
      }

      // Update goal number
      $('.campaign-dashboard-goal-number').html(goal);

      // Update hidden input
      $currentGoalInput.val(goal);
    }
  }

  $('.progress-container .back-to-top').click(function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: 0
    }, 500);
  });

  var $changeGoalDialogContainer = $('.change-goal-dialog-container');
  var $progressTimeLineContainer = $('.campaign-progress .progress-container');

  if ($progressTimeLineContainer.length) {
    $progressTimeLineContainer.find('.campaign-progress-ride-goal').click(function () {
      window.SC.progressDialog.open($(this));
    });

    $changeGoalDialogContainer.find('.change-goal-dialog-overlay, .change-goal-dialog-close, .change-goal-dialog-button.button-done').click(function () {
      window.SC.progressDialog.close();
      SC.analytics.mp.sendEvent('Dismiss', 'navigation', {'Location': 'Goal Detail'}, 'Goal Detail');
    });

    $changeGoalDialogContainer.find('.change-goal-dialog-button.button-change').click(function () {
      window.SC.progressDialog.confirm();
    });

    // Here are a few events for analytic tracking
    $('.view-all-rides').click(function () {
      SC.analytics.mp.logEvent('Challenge_Spring19 - View All Rides', 'navigation');
    });

    $('.back-to-top').click(function () {
      SC.analytics.mp.logEvent('Challenge_Spring19 - Back to Top', 'navigation');
    });

    $('.go-to-schedule').click(function () {
      SC.analytics.mp.logEvent('Challenge_Spring19 - Go to Schedule', 'navigation');
    });

    $('.back-to-dashboard').click(function () {
      SC.analytics.mp.logEvent('Challenge_Spring19 - Back to Dashboard', 'navigation');
    });

    window.SC.progressDialog = new ProgressGoalDialog();
  }

  updateDashboardUI();
})(window, jQuery);
